import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ConfigurarCuentaDTO } from '../dto/configurar-cuentaDTO';
import { ConfigurarCuentasService } from '../services/configurar-cuentas.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { DataUsuario } from '../dto/data-usuarioDTO';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { Constants } from '../../../constants/constants';
import { ModalDatosAdicionalesComponent } from '../../util/modal-datos/modal-datos-adicionales/modal-datos-adicionales.component';
import { ModalDatosAdicionalesAbogadoComponent } from '../../util/modal-datos/modal-datos-adicionales-abogado/modal-datos-adicionales-abogado.component';
import { AutenticacionService } from '../../auth/services/autenticacion.service';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { PaisDto } from "../../../dto/expediente/pais.dto";
import { DepartmentoDto } from "../../../dto/expediente/departmento.dto";
import { MunicipioDto } from "../../../dto/expediente/municipio.dto";
import { ListasService } from "../../../services/listas.service";
import { UsuarioService } from '../../../services/usuario.service';
import { LanguageService } from '../../../services/util/language.service';

@Component({
  selector: 'app-configurar-cuenta',
  templateUrl: './configurar-cuenta.component.html',
  styleUrl: './configurar-cuenta.component.scss',
})
export class ConfigurarCuentaComponent implements OnInit {
  @ViewChild(ModalDatosAdicionalesComponent)
  ModalDatosAdicionalesComponent!: ModalDatosAdicionalesComponent;
  @ViewChild(ModalDatosAdicionalesAbogadoComponent)
  ModalDatosAdicionalesAbogadoComponent!: ModalDatosAdicionalesAbogadoComponent;
  // Formularios
  preferenciasForm!: FormGroup;
  dataUsuario!: DataUsuario;
  rolUsuario!: any;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  isPersona = false;
  openModalPersona = false;
  isAbogado = false;
  openModalAbogado = false;
  // Multilenguaje
  configurarText: any = {};
  comunText: any = {};

  // Number
  anioActual: number;

  // Listas
  paises: PaisDto[] = [];
  departamentos: DepartmentoDto[] = [];
  municipios: MunicipioDto[] = [];

  idiomaActual: string = 'es';

  // Boolean
  esColombia = true;
  moreUsuarios: boolean = false;
  constructor(
    private readonly fb: FormBuilder,
    private readonly _cuentaService: ConfigurarCuentasService,
    private readonly alertService: AlertaModalService,
    private readonly utilService: UtilService,
    private readonly autenticacionService: AutenticacionService,
    private readonly translate: TranslateService,
    private readonly listasService: ListasService,
    private readonly usuarioService: UsuarioService,
    private languageService: LanguageService
  ) {
    this.anioActual = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();
    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
      this.cambioIdioma();
    });
    combineLatest([
      this.translate.stream('configuracion-cuenta'),
      this.translate.stream('comun-label'),
    ]).subscribe(([configurarText, comunLabelText]) => {
      for (const key of Object.keys(configurarText)) {
        this.configurarText[key] = configurarText[key];
      }
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }
    });
    // Se obtiene la lista de países
    this.listarPaises();
    this.preferenciasForm = this.fb.group({
      telefono: [
        null,
        [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(10),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
      ],
      direccion: [
        null,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
      ],
      notificaciones: [true],
      primerNombre: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
      ],
      segundoNombre: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
      ],
      primerApellido: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
      ],
      segundoApellido: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
      ],
      fechaNacimiento: [
        '',
        [
          Validators.required,
          this.edadMinimaValidator(18)
        ],
      ],
      nacionalidad: [],
      pais: ['', [Validators.required]],
      departamento: ['', [Validators.required]],
      municipio: ['', [Validators.required]],
      otroDepartamento: ['', [
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
        Validators.maxLength(30)
      ]],
      otroMunicipio: ['', [
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
        Validators.maxLength(30)
      ]],
    });
    this.obtenerDataUsuario();
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: 'Configuración de cuenta',
      descripcionPantalla:
        'En esta pantalla usted podrá editar su información personal y ' +
        'cambiar sus preferencias',
      pasos: [],
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
    this.verificarUsuario();
    this.consultarTiposUsuario();
  }
  // Se consume el servicio que lista los países
  listarPaises() {
    this.listasService.getCountryList().subscribe((paises: PaisDto[]) => {
      this.paises = paises;
    });
  }
  /**
   * Metodos usuario logeado
   */
  cambioIdioma() {
    if (this.dataUsuario?.idUsuario) {
      this.consultarTiposUsuario();
    }
  }
  obtenerDataUsuario() {
    const data = sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE);
    const dataRol = sessionStorage.getItem(Constants.USER_TYPE);
    this.dataUsuario = data != null ? JSON.parse(data) : null;
    this.rolUsuario = JSON.parse(dataRol!).Nombre;
    this.getDataUser(this.dataUsuario.idUsuario);
  }

  getDataUser(idUsuario: number) {
    this._cuentaService
      .getDataPersonal(idUsuario)
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.preferenciasForm
            .get('telefono')
            ?.setValue(response.data.Telefono_Principal);
          this.preferenciasForm
            .get('direccion')
            ?.setValue(
              this.recorrerDireccionPersona(response.data.Direccion_Persona)
            );
          this.preferenciasForm
            .get('notificaciones')
            ?.setValue(response.data.Usuario.Recibir_notificaciones_correo);
          this.preferenciasForm
            .get('primerNombre')
            ?.setValue(response.data.Persona_Natural[0].Primer_nombre);
          this.preferenciasForm
            .get('segundoNombre')
            ?.setValue(response.data.Persona_Natural[0].Segundo_nombre);
          this.preferenciasForm
            .get('primerApellido')
            ?.setValue(response.data.Persona_Natural[0].Primer_apellido);
          this.preferenciasForm
            .get('segundoApellido')
            ?.setValue(response.data.Persona_Natural[0].Segundo_apellido);
          let fecha = new Date(response.data.Persona_Natural[0].Fecha_Nacimiento);
          let fechaFormateada = fecha.toISOString().split('T')[0];
          this.preferenciasForm
            .get('fechaNacimiento')
            ?.setValue(fechaFormateada);
          this.preferenciasForm
            .get('nacionalidad')
            ?.setValue(response.data.Persona_Natural[0].Id_Nacionalidad);
          this.preferenciasForm
            .get('pais')
            ?.setValue(response.data.Municipio.Departamento.Pais.Id);
          // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
          const idPais = this.paises.find(
            item => item.Codigo == Constants.CODIGO_COLOMBIA
          )?.Id;
          response.data.Municipio.Departamento.Pais.Id == idPais ? this.esColombia = true : this.esColombia = false;
          if (this.esColombia) {
            // Se consume el servicio de listar departamentos de acuerdo al ID del país guardado previamente
            this.listasService
              .getDepartmentList(response.data.Municipio.Departamento.Pais.Id)
              .subscribe((departamentos: DepartmentoDto[]) => {
                this.departamentos = departamentos;
              });
            this.preferenciasForm
              .get('departamento')
              ?.setValue(response.data.Municipio.Departamento.Id);
            // Se consume el servicio de listar municipios de acuerdo al ID del departamento guardado previamente
            this.listasService
              .getMunicipalityList(response.data.Municipio.Departamento.Id)
              .subscribe((municipios: MunicipioDto[]) => {
                this.municipios = municipios;
              })
            this.preferenciasForm
              .get('municipio')
              ?.setValue(response.data.Municipio.Id);
            this.setearUbicacion(this.esColombia);
          } else {
            this.preferenciasForm
              .get('municipio')
              ?.setValue(response.data.Municipio.Id);
            this.preferenciasForm
              .get('otroDepartamento')
              ?.setValue(response.data.Otro_Departamento);
            this.preferenciasForm
              .get('otroMunicipio')
              ?.setValue(response.data.Otro_Municipio);
            this.setearUbicacion(this.esColombia);
          }
        } else {
          this.alertService.error(response.message);
        }
      });
  }

  recorrerDireccionPersona(
    auxArreglo: {
      Id: number;
      Id_Persona: number;
      Direccion_Notificacion: string;
      Es_Primaria: boolean;
    }[]
  ): string {
    let direccion = '';
    auxArreglo.forEach(
      (elemento: {
        Id: number;
        Id_Persona: number;
        Direccion_Notificacion: string;
        Es_Primaria: boolean;
      }) => {
        if (elemento.Es_Primaria) {
          direccion = elemento.Direccion_Notificacion;
        }
      }
    );
    return direccion;
  }

  getNombreUsuario(): string {
    const arrayAux = [this.dataUsuario];
    let nombreUsuario = '';
    arrayAux.forEach((elemento: DataUsuario) => {
      nombreUsuario =
        this.validarNull(elemento.primerNombre) +
        ' ' +
        this.validarNull(elemento.segundoNombre) +
        ' ' +
        this.validarNull(elemento.primerApellido) +
        ' ' +
        this.validarNull(elemento.segundoApellido);
    });
    return nombreUsuario;
  }

  getInicialesNombreUsuario() {
    const arrayAux = [this.dataUsuario];
    let nombreUsuario = '';
    arrayAux.forEach((elemento: DataUsuario) => {
      nombreUsuario =
        this.validarNull(elemento.primerNombre) +
        ' ' +
        this.validarNull(elemento.primerApellido);
    });
    return nombreUsuario;
  }

  getNumeroDocumento() {
    return (
      this.dataUsuario.tipoDocumento + ' : ' + this.dataUsuario.identificacion
    );
  }

  getTipoUsuario() {
    const usuarioTexto = this.configurarText['usuario'];
    return `${usuarioTexto} ${this.rolUsuario}`;
  }

  getEmail() {
    return this.dataUsuario.correoElectronico;
  }

  validarNull(elemento: string): string {
    return elemento ?? '';
  }

  obtenerDireccion(direccion: string) {
    this.preferenciasForm.get('direccion')?.setValue(direccion);
  }

  guardar() {
    const json: ConfigurarCuentaDTO = {
      id: this.dataUsuario.idUsuario,
      recibirNotificacionesCorreo:
        this.preferenciasForm.get('notificaciones')?.value,
      direccionNotificacion: this.preferenciasForm.get('direccion')?.value,
      telefonoPrincipal: this.preferenciasForm.get('telefono')?.value,
      primerNombre: this.preferenciasForm.get('primerNombre')?.value,
      segundoNombre: this.preferenciasForm.get('segundoNombre')?.value,
      primerApellido: this.preferenciasForm.get('primerApellido')?.value,
      segundoApellido: this.preferenciasForm.get('segundoApellido')?.value,
      idNacionalidad: parseInt(this.preferenciasForm.get('nacionalidad')?.value),
      idMunicipio: parseInt(this.preferenciasForm.get('municipio')?.value),
      otroDepartamento: this.preferenciasForm.get('otroDepartamento')?.value,
      otroMunicipio: this.preferenciasForm.get('otroMunicipio')?.value,
      fechaNacimiento: this.preferenciasForm.get('fechaNacimiento')?.value
    };
    this._cuentaService
      .saveConfiguracionCuenta(json)
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.alertService.exito(`${response.message}`).then(() => {
            this.updateDetalle(json);
          });
        } else {
          this.alertService.error(response.message);
        }
      });
  }

  updateDetalle(data: ConfigurarCuentaDTO) {
    let datosSesion: UserDataDto = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    datosSesion.primerNombre = data.primerNombre;
    datosSesion.segundoNombre = data.segundoNombre;
    datosSesion.primerApellido = data.primerApellido;
    datosSesion.segundoApellido = data.segundoApellido;
    sessionStorage.setItem(
      Constants.USER_INFORMATION_STORAGE,
      JSON.stringify(datosSesion)
    );
    window.location.reload();
  }

  // Función que valida los campos de acuerdo al formulario
  validateField(form: FormGroup, field: string): boolean {
    return (
      ((form.get(field)?.dirty || form.get(field)?.touched) &&
        form.get(field)?.invalid) ||
      false
    );
  }

  verificarUsuario() {
    const dataRol = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) || '{}'
    );
    if (dataRol.Nombre == 'Ciudadano') {
      // Usuario Ciudadano
      this.isPersona = true;
    } else if (dataRol.Nombre == 'Abogado') {
      // Usuario Abogado
      this.isAbogado = true;
    }
  }

  abrirModalPersona() {
    this.openModalPersona = true;
    setTimeout(() => {
      this.ModalDatosAdicionalesComponent.abrirModal();
    }, 500);
  }

  abrirModalAbogado() {
    this.openModalAbogado = true;
    setTimeout(() => {
      this.ModalDatosAdicionalesAbogadoComponent.abrirModal();
    }, 500);
  }

  enviarMensajeCambiarContrasena(): void {
    this.autenticacionService.actualizarContrasena().subscribe({
      next: () => {
        this.alertService.exito(
          this.configurarText['cambiar-contrasenia-tituloModal'],
          this.configurarText['cambiar-contrasenia-modal']
        );
      },
      error: () => {
        this.alertService.error(
          this.configurarText['error-modal-titulo'],
          this.configurarText['error-modal']
        );
      },
    });
  }

  transformToUppercase(fieldName: string): void {
    const control = this.preferenciasForm.get(fieldName);
    if (control) {
      const uppercasedValue = control.value.toUpperCase();
      control.setValue(uppercasedValue, { emitEvent: false });
    }
  }

  validarAnio(event: Event) {
    const input = event.target as HTMLInputElement;
    const fechaIngresada = new Date(input.value);
    if (fechaIngresada.getFullYear() > this.anioActual) {
      fechaIngresada.setFullYear(this.anioActual);
      input.value = fechaIngresada.toISOString().split('T')[0];
      this.preferenciasForm.get('fechaNacimiento')?.setValue(input.value);
    }
  }

  // Función que valida la edad ingresada sea mayor a 18 años
  edadMinimaValidator(aniosRequeridos: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const fechaNacimiento = control.value;
      if (!fechaNacimiento) {
        return null; // No validar si no hay valor
      }

      const fechaNacimientoDate = new Date(fechaNacimiento);
      const fechaActual = new Date();

      // Cálculo exacto de la edad considerando mes y día
      let edad = fechaActual.getFullYear() - fechaNacimientoDate.getFullYear();
      const mes = fechaActual.getMonth() - fechaNacimientoDate.getMonth();
      const dia = fechaActual.getDate() - fechaNacimientoDate.getDate();

      if (mes < 0 || (mes === 0 && dia < 0)) {
        edad--; // Resta un año si aún no ha pasado su cumpleaños
      }

      return edad < aniosRequeridos ? { edadRequerida: true } : null;
    };
  }

  // Función que consume el servicio de listar departamentos de acuerdo al país seleccionado
  obtenerDepartamentos(event: any) {
    this.listasService
      .getDepartmentList(event.target.value)
      .subscribe((departamentos: DepartmentoDto[]) => {
        this.departamentos = departamentos;
        // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
        const idPais = this.paises.find(
          item => item.Codigo == Constants.CODIGO_COLOMBIA
        )?.Id;
        event.target.value == idPais ? this.esColombia = true : this.esColombia = false;
        if (!this.esColombia) {
          let departamentoId = 0;
          this.preferenciasForm.get('departamento')?.setValue('');
          this.departamentos.forEach((departamento: DepartmentoDto) => {
            departamentoId = departamento.Id;
          });
          this.listasService
            .getMunicipalityList(departamentoId)
            .subscribe((municipios: MunicipioDto[]) => {
              municipios.forEach(elemento => {
                this.preferenciasForm.get('municipio')?.setValue(elemento.Id);
              })
            });
          this.preferenciasForm.get('otroDepartamento')?.setValue('');
          this.preferenciasForm.get('otroMunicipio')?.setValue('');
          this.municipios = [];
          this.setearUbicacion(false);
        } else {
          this.preferenciasForm.get('municipio')?.setValue(null);
          this.preferenciasForm.get('otroDepartamento')?.setValue('');
          this.preferenciasForm.get('otroMunicipio')?.setValue('');
          this.setearUbicacion(true);
        }
      });
  }

  // Función que consume el servicio de listar municipios de acuerdo al departamento seleccionado
  obtenerMunicipios(event: any) {
    this.listasService
      .getMunicipalityList(this.esColombia ? event.target.value : event)
      .subscribe((municipios: MunicipioDto[]) => {
        this.municipios = municipios;
        if (!this.esColombia) {
          this.preferenciasForm.get('municipio')?.setValue('');
          this.municipios = [];
        } else {
          this.municipios = municipios;
        }
      });
  }

  setearValidadoresForm(
    form: FormGroup,
    nombreCampo: string,
    validadores: any
  ) {
    form.controls[nombreCampo].setValidators(
      validadores
    );
    form.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  setearUbicacion(flag: boolean) {
    if (flag) {
      this.setearValidadoresForm(
        this.preferenciasForm,
        'departamento',
        [Validators.required]);
      this.setearValidadoresForm(
        this.preferenciasForm,
        'municipio',
        [Validators.required]);
      this.setearValidadoresForm(
        this.preferenciasForm,
        'otroDepartamento',
        null);
      this.setearValidadoresForm(
        this.preferenciasForm,
        'otroMunicipio',
        null);
    } else {
      this.setearValidadoresForm(
        this.preferenciasForm,
        'otroDepartamento',
        [Validators.required,
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
        Validators.maxLength(30)
        ]);
      this.setearValidadoresForm(
        this.preferenciasForm,
        'otroMunicipio',
        [Validators.required,
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
        Validators.maxLength(30)
        ]);
      this.setearValidadoresForm(
        this.preferenciasForm,
        'departamento',
        null);
      this.setearValidadoresForm(
        this.preferenciasForm,
        'municipio',
        null);
    }
  }
  consultarTiposUsuario() {
    this.usuarioService.consultarTiposUsuario(this.dataUsuario.idUsuario, this.idiomaActual).subscribe({
      next: resp => {
        if (resp.tiposUsuario && resp.tiposUsuario.length > 0) {
          const rolEncontrado = resp.tiposUsuario.find(
            (tipo: any) => tipo.Tipo_Usuario === this.rolUsuario
          );

          // Si existe, se mantiene; si no, se asigna el primero
          this.rolUsuario = rolEncontrado
            ? rolEncontrado.Tipo_Usuario
            : resp.tiposUsuario[0].Tipo_Usuario;
        }
        if (resp.tiposUsuario.length == 1) {
          this.moreUsuarios = true;
        } else {
          this.moreUsuarios = false;
        }
      },
    });
  }
}
